// extracted by mini-css-extract-plugin
module.exports = {"context":"context-3SXCy","text":"text-2bwQZ","icon":"icon-2-NBv"};